import React from 'react'
import propTypes from 'prop-types'
import classNames from 'classnames'

import InputTextWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'
import Button from 'views/components/atoms/Button'
import ButtonSecondary from 'views/components/molecules/ButtonSecondary'
import TextWithIcon from 'views/components/molecules/TextWithIcon'

import './InputWithButton.scss'

const InputWithButton = ({
  type,
  autoFocus,
  buttonIcon,
  buttonIconSize,
  buttonLabel,
  buttonLabelShort,
  buttonPrimary,
  children,
  disableAutoCompleteAndFriends,
  inputId,
  name,
  onChange,
  onClear,
  onClick,
  onKeyUp,
  rounded,
  value,
  placeholder,
  buttonType,
  mediumViewIconOnly,
  grayInputBg
}) => {
  const ButtonComponent = buttonPrimary ? Button : ButtonSecondary
  const id = inputId || name
  const buttonProps = {
    className: 'm-InputWithButton__button',
    name: `${name}-button`,
    rounded,
    roundedRight: rounded
  }

  if (onClick) {
    buttonProps.onClick = onClick
  } else if (buttonType) {
    buttonProps.type = buttonType
  }

  const inputClassNames = classNames('m-InputWithButton__input', {
    'm-InputWithButton__input--gray-bg': grayInputBg
  })

  return (
    <div className="m-InputWithButton l-flex l-flex--stretch-children">
      <InputTextWithFloatingLabel
        inputType={type}
        name={name}
        id={id}
        autoFocus={autoFocus}
        disableAutoCompleteAndFriends={disableAutoCompleteAndFriends}
        onKeyUp={onKeyUp}
        onChange={onChange}
        value={value}
        onClear={onClear}
        inputClassname={inputClassNames}
        rounded={rounded}
        roundedLeft={rounded}
        placeholder={placeholder}
      >
        {children}
      </InputTextWithFloatingLabel>
      <ButtonComponent {...buttonProps} inline>
        <TextWithIcon icon={buttonIcon} iconSize={buttonIconSize}>
          <span
            className={
              mediumViewIconOnly
                ? 'u-hidden u-visible@large'
                : 'u-hidden@small-tiny'
            }
          >
            {buttonLabel}
          </span>
          <span className="u-hidden@medium">{buttonLabelShort}</span>
        </TextWithIcon>
      </ButtonComponent>
    </div>
  )
}

InputWithButton.propTypes = {
  children: propTypes.node,
  type: propTypes.string,
  onClick: propTypes.func,
  buttonLabel: propTypes.string.isRequired,
  buttonLabelShort: propTypes.string,
  buttonIcon: propTypes.string,
  buttonIconSize: propTypes.string,
  buttonPrimary: propTypes.bool,
  inputId: propTypes.string,
  name: propTypes.string.isRequired,
  disableAutoCompleteAndFriends: propTypes.bool,
  onKeyUp: propTypes.func,
  onChange: propTypes.func,
  onClear: propTypes.func,
  value: propTypes.string,
  placeholder: propTypes.string,
  autoFocus: propTypes.bool,
  rounded: propTypes.bool,
  buttonType: propTypes.string,
  mediumViewIconOnly: propTypes.bool,
  grayInputBg: propTypes.bool
}

InputWithButton.defaultProps = {
  type: 'text',
  buttonIcon: '',
  children: null,
  buttonIconSize: null,
  buttonLabelShort: '',
  buttonPrimary: false,
  inputId: null,
  disableAutoCompleteAndFriends: false,
  onKeyUp: null,
  onChange: null,
  onClear: null,
  value: null,
  autoFocus: false,
  rounded: true,
  placeholder: null,
  buttonType: '',
  onClick: null,
  mediumViewIconOnly: false,
  grayInputBg: false
}

export default InputWithButton
